module.exports = __webpack_public_path__ + "static/media/gifts.e2145b69.svg";